export enum CliRequestSearchType {
  NoFilter = '',
  ConsumerId = 'ConsumerId',
  ConsumerName = 'ConsumerName',
}
